export default __webpack_public_path__ + "static/footermock-73bf4feab45f64dcdc16e0d4012cabd5.png";